export const LOGIN_USER = "loginUser";
export const SET_USER = "setUser";
export const SET_USER_ACCOUNTS = "setUserAccounts";
export const SET_USER_TOKEN = "setUserToken";
export const SET_REFRESH_TOKEN = "setRefreshToken";
export const SET_LOGGED_IN = "setLoggedOut";
export const SET_ACTIVE_ACCOUNT = "setActiveAccount";
export const SET_TIMEZONES = "setTimezones";
export const CREATE_POST = "createPost";
export const SET_EDIT_POST_DATA = "setEditPostData";
export const DELETE_POST = "deletePost";
export const SET_EDIT_DRAFT_DATA = "setEditDraftData";
export const GET_BRANDS = "getBrands";
export const UPDATE_BRAND = "updateBrand";
export const DELETE_BRAND = "deleteBrand";
export const UPLOAD_MEDIA = "uploadMedia";
export const GET_POSTS = "getPosts";
export const GET_SCHEDULED_POSTS = "getScheduledPosts";
export const POST_ACTION = "postAction";
export const SET_SCHEDULE_DATA = "setScheduleData";
export const SET_BRAND_DETAILS = "setBrandDetails";
export const SET_AI_BRAND_INFO = "setAiBrandInfo";
export const SET_BRAND_FORM = "setBrandForm";
export const SET_LOGIN_DATA = "setLoginData";
export const CHANGE_NOTIFICATION_SETTINGS = "set_notification_settings";
export const GET_CURRENT_SUB = "getCurrentSub";
export const SET_LATEST_NOTIFICATIONS = "setLatestNotifications";
export const GET_ALL_NOTIFICATIONS = "getAllNotifications";
export const SET_ALERT_DETAILS = "setAlertDetails";
export const SET_REDIRECT_URL = "setRedirectUrl";
export const SHOW_NOTIFICATIONS_BADGE = "showNotificationsBadge";
export const SHOW_DMS_BADGE = "showDmsBadge";
export const SHOW_COMMENTS_BADGE = "showCommentsBadge";
export const SET_NEW_NOTIFICATION = "setNewNotification";
export const SET_NEW_CONVERSATIONS = "setNewConversations";
export const SET_NEW_POST_STATUS = "setNewPostStatus";
export const TOGGLE_EXPIRED_BANNER = "toggleExpiredBanner";
export const GET_PLANS = "getPlans";
export const SET_PAGE_TITLE = "setPageTitle";
export const SET_MEMBER = "setMember";
export const GET_MEMBERS = "getMembers";
export const GET_INVITES = "getInvites";
export const RESET = "reset";
export const GET_TOOLTIP = "getTooltip";
export const GET_DEBIT_CARDS = "getDebitCards";
export const GET_BANKS = "getBanks";
export const SET_PLANNER = "setPlanner";
export const SET_SHOW_APP_MODAL = "setShowAppModal";
